// LCP fix: remove lazy loading from collection hero image (Breadcrumbs & Categories app)
document.addEventListener('DOMContentLoaded', function() {
  var heroImg = document.querySelector('.oh__assets__image');
  if (heroImg) {
    heroImg.removeAttribute('loading');
    heroImg.setAttribute('fetchpriority', 'high');
  }
});

// Shared "Select size" / "Add to cart" controller for the desktop
// product-form button and the mobile sticky bar button (see
// snippets/sticky-add-to-cart.liquid). Both buttons read from the exact same
// state computed here — no duplicated variant-matching logic. No-ops on
// products with no real variant options, and on any page without the form.
//
// Behaviour:
// - Starts (and stays) on "Select size" until the shopper has explicitly
//   changed every option at least once, even though the theme pre-checks a
//   default variant's radios on page load — tracked via `touched`, not the
//   DOM's initial checked state.
// - Once every option has been touched, resolves the actual selected
//   combination against the product's variants JSON (already embedded in
//   the page as [data-variant-json], the same source theme.js itself reads)
//   rather than the theme's own custom 'variant:change' events — this
//   avoids depending on assumptions about theme.js's internal event
//   dispatch order. render() is deferred with setTimeout so it always runs
//   after any of the theme's own native 'change' handlers on the same
//   inputs have already finished.
// - "Select size" state: both buttons stay enabled and clicking scrolls to
//   (and focuses) the size option's fieldset instead of submitting.
// - "Add to cart" state: the desktop button submits the form normally; the
//   sticky button proxy-clicks the desktop button so the existing AJAX
//   cart/cart drawer/dynamic checkout logic is reused, not duplicated.
document.addEventListener('DOMContentLoaded', function () {
  var mainForm = document.querySelector('.product-single__form');
  var desktopButton = mainForm && mainForm.querySelector('[data-add-to-cart]');
  if (!desktopButton || !desktopButton.hasAttribute('data-requires-selection')) return;

  var productSection = mainForm.closest('[data-section-type="product"]') || document;
  var variantJsonEl = productSection.querySelector('[data-variant-json]');
  var optionInputs = productSection.querySelectorAll('[data-variant-input]');
  var desktopButtonText = desktopButton.querySelector('[data-add-to-cart-text]');
  var optionsCount = parseInt(desktopButton.getAttribute('data-options-count'), 10) || 0;
  var scrollTargetId = desktopButton.getAttribute('data-select-size-target');

  // Storefront language for the JS-swapped button labels. <html lang> is set
  // server-side from request.locale.iso_code, so /it and /de get localized
  // "Select size" / "Out of stock" without any locale-file round trip.
  var docLang = (document.documentElement.lang || 'en').split('-')[0];
  var atcI18n = ({
    it: { select: 'Seleziona la taglia', soldout: 'Esaurito', add: 'Aggiungi al carrello' },
    de: { select: 'Größe wählen', soldout: 'Ausverkauft', add: 'In den Einkaufswagen legen' }
  })[docLang] || { select: 'Select size', soldout: 'Out of stock', add: 'Add to cart' };

  var defaultReadyText = (desktopButtonText && desktopButtonText.dataset.defaultText) || atcI18n.add;

  var stickyButton = document.querySelector('[data-sticky-atc-button]');
  var stickyButtonText = stickyButton && stickyButton.querySelector('[data-sticky-atc-button-text]');

  var variants = [];
  try {
    variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];
  } catch (e) {
    variants = [];
  }

  var soldOutText = atcI18n.soldout;
  var touched = {};
  var state = 'select'; // 'select' | 'ready' | 'soldout'

  // Options that have only one possible value can never be "changed" by the
  // shopper, so pre-mark them as touched. Without this, a product with a
  // single size (and/or a single colour) never satisfies allOptionsTouched(),
  // so its button stays on "Select size" and clicking it only scrolls — it
  // never submits. (Fixes the single-size + single-colour "button not
  // working" bug.)
  var groupSizes = {};
  optionInputs.forEach(function (input) {
    groupSizes[input.dataset.index] = (groupSizes[input.dataset.index] || 0) + 1;
  });
  Object.keys(groupSizes).forEach(function (index) {
    if (groupSizes[index] === 1) touched[index] = true;
  });

  function allOptionsTouched() {
    return Object.keys(touched).length >= optionsCount;
  }

  function getSelectedOptions() {
    var selected = [];
    var seen = {};
    optionInputs.forEach(function (input) {
      if (!input.checked || seen[input.dataset.index]) return;
      seen[input.dataset.index] = true;
      selected.push({ index: input.dataset.index, value: input.value });
    });
    return selected;
  }

  function findMatchingVariant() {
    var selected = getSelectedOptions();
    if (selected.length < optionsCount) return null;
    return (
      variants.find(function (variant) {
        return selected.every(function (opt) {
          var position = parseInt(String(opt.index).replace('option', ''), 10);
          return variant['option' + position] === opt.value;
        });
      }) || null
    );
  }

  function applyState(button, textEl) {
    // Sold-out selection: show "Out of stock" on the Add to cart button and
    // disable it so it can't submit. The size buttons themselves are left
    // untouched.
    button.disabled = state === 'soldout';
    if (!textEl) return;
    if (state === 'ready') {
      textEl.textContent = defaultReadyText;
    } else if (state === 'soldout') {
      textEl.textContent = soldOutText;
    } else {
      textEl.textContent = atcI18n.select;
    }
  }

  function render() {
    var variant = allOptionsTouched() ? findMatchingVariant() : null;
    if (!variant) {
      state = 'select';
    } else if (variant.available) {
      state = 'ready';
    } else {
      state = 'soldout';
    }

    applyState(desktopButton, desktopButtonText);
    if (stickyButton) applyState(stickyButton, stickyButtonText);
  }

  function scrollToSize() {
    var target = scrollTargetId && document.getElementById(scrollTargetId);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  render();

  // 'change' covers the option the shopper directly clicked. 'updateSwatch'
  // (dispatched by theme.js's own dynamic-variant matching, see theme.js
  // Variants._updateInputState) covers options theme.js auto-selects on the
  // shopper's behalf via a direct `.checked = true` assignment, which does
  // not fire a native 'change' event — without this, an auto-selected
  // option would never register as touched and the button would stay on
  // "Select size" forever even though every option is visibly selected.
  optionInputs.forEach(function (input) {
    ['change', 'updateSwatch'].forEach(function (eventName) {
      input.addEventListener(eventName, function () {
        touched[input.dataset.index] = true;
        setTimeout(render, 0);
      });
    });
  });

  desktopButton.addEventListener('click', function (event) {
    if (state === 'ready') return; // let the click proceed as a normal form submit
    event.preventDefault();
    if (state === 'select') scrollToSize();
    // soldout: the button shows "Out of stock" and is disabled, so this
    // handler won't fire.
  });

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (state === 'ready') {
        // Proxy to the real submit button so the existing AJAX cart, cart
        // drawer, and variant validation logic all keep working untouched.
        desktopButton.click();
        return;
      }
      if (state === 'select') scrollToSize();
      // soldout: the sticky button shows "Out of stock" and is disabled.
    });
  }
});

// Sticky mobile "Select size" / "Add to cart" bar visibility: hides itself
// once the real (non-sticky) product-form Add to Cart button is visible in
// the viewport, and reappears once it's scrolled out of view again — the
// bar "anchors" to the button's original position. IntersectionObserver
// only, no scroll listeners.
document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('.product-single__form');
  var mainButton = mainForm && mainForm.querySelector('[data-add-to-cart]');
  if (!stickyBar || !mainButton) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('is-hidden', entry.isIntersecting);
    });
  });

  observer.observe(mainButton);
});

// Horizontal product tab bar (see snippets/product-template.liquid). Only
// one panel open at a time; clicking the already-active tab is a no-op
// (no toggle/collapse). Vanilla JS, no libraries.
//
// Delegated on `document` rather than bound per wrapper on DOMContentLoaded,
// because the Quick View modal's product content is fetched and injected by
// theme.js's quick-shop AFTER load — a load-time binding would never reach
// those tabs, so they'd render but not switch. A single document listener
// also means opening many Quick Views can't stack duplicate handlers. Each
// click resolves its own [data-product-tabs] wrapper and scopes the
// trigger/panel updates to it, so the modal's tabs and the underlying
// product-page tabs never affect one another (even though panel IDs repeat
// when the same product is shown in both).
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-tab-trigger]');
  if (!trigger) return;

  var wrapper = trigger.closest('[data-product-tabs]');
  if (!wrapper) return;

  // Clicking the already-active tab does nothing — no toggle/collapse.
  if (trigger.classList.contains('is-active')) return;

  var targetId = trigger.getAttribute('aria-controls');

  wrapper.querySelectorAll('[data-tab-trigger]').forEach(function (t) {
    var isActive = t === trigger;
    t.classList.toggle('is-active', isActive);
    t.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  wrapper.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
    var isActive = panel.id === targetId;
    panel.classList.toggle('is-active', isActive);
    panel.toggleAttribute('hidden', !isActive);
  });

  trigger.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
});

// Relocate the breadcrumb into the product info column.
// The breadcrumb is rendered by the Breadcrumbs & Categories app as a block in
// the (global) header group, so it renders above the full-width product layout.
// On product pages we MOVE that same element (server-rendered, so present at
// DOMContentLoaded) to the top of the product info column, directly above the
// vendor — moved, not cloned, so its existing styling is preserved and no
// duplicate is produced. The now-empty original section is hidden so no gap is
// left above the layout. No-ops on non-product pages and if the app block is
// absent.
document.addEventListener('DOMContentLoaded', function () {
  var productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  var meta = productSection.querySelector('.product-single__meta');
  var crumbInner = document.querySelector('.breadcrumbs-on-product');
  if (!meta || !crumbInner) return;

  var crumb = crumbInner.closest('.shopify-app-block') || crumbInner;
  var originalSection = crumb.closest('.shopify-section');

  // Same placement on every viewport: the top of the product info column, above
  // the vendor. On desktop that's the top of the right-hand column; on mobile
  // the column stacks under the image, giving
  // image -> breadcrumb -> vendor -> title -> price. Mobile-specific spacing is
  // applied in product-redesign.css; desktop keeps the column's default spacing.
  meta.insertBefore(crumb, meta.firstChild);
  crumb.classList.add('pdp-breadcrumb-moved');

  // Hide the now-empty original header-group slot it came from.
  if (originalSection && !originalSection.querySelector('.shopify-app-block')) {
    originalSection.style.display = 'none';
  }
});

// Product gallery: replace Flickity's page dots with a sliding progress bar and
// add subtle prev/next chevron arrows (styled/shown on mobile in
// product-redesign.css). The gallery logic (theme.js Flickity on
// [data-product-photos]) is NOT touched — we only READ its page dots to know
// the active index, and call the existing Flickity instance's previous()/next()
// for the arrows. Elements are appended only after Flickity has initialised
// (dots present), so they're never mistaken for slides.
document.addEventListener('DOMContentLoaded', function () {
  var slideshow = document.querySelector('[data-section-type="product"] [data-product-photos]');
  if (!slideshow || slideshow.querySelectorAll('.product-main-slide').length < 2) return;

  var built = false;
  function build() {
    if (built || !slideshow.querySelector('.flickity-page-dots')) return;
    built = true;

    var bar = document.createElement('div');
    bar.className = 'pdp-progress';
    var fill = document.createElement('div');
    fill.className = 'pdp-progress__fill';
    bar.appendChild(fill);
    slideshow.appendChild(bar);

    ['prev', 'next'].forEach(function (dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-gallery-arrow pdp-gallery-arrow--' + dir;
      btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      // Thin line arrow (matches the reference). currentColor lets the CSS set
      // the stroke colour.
      btn.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="20" y1="12" x2="4" y2="12"/><polyline points="11 5 4 12 11 19"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="12" x2="20" y2="12"/><polyline points="13 5 20 12 13 19"/></svg>';
      btn.addEventListener('click', function () {
        var flkty = window.Flickity && Flickity.data(slideshow);
        if (flkty) { dir === 'prev' ? flkty.previous() : flkty.next(); }
      });
      slideshow.appendChild(btn);
    });

    function update() {
      var dots = slideshow.querySelectorAll('.flickity-page-dots .dot');
      if (!dots.length) return;
      fill.style.width = (100 / dots.length) + '%';
      var index = 0;
      dots.forEach(function (d, i) { if (d.classList.contains('is-selected')) index = i; });
      fill.style.transform = 'translateX(' + (index * 100) + '%)';
    }
    update();
    // Watch the selected-dot class toggles Flickity makes on swipe/navigation.
    new MutationObserver(update).observe(slideshow, {
      attributes: true, subtree: true, attributeFilter: ['class']
    });
  }

  build();
  if (!built) {
    var wait = new MutationObserver(function () {
      build();
      if (built) wait.disconnect();
    });
    wait.observe(slideshow, { childList: true, subtree: true });
  }
});

// Photo zoom (PhotoSwipe) exit fix. On iOS the theme adds `pswp-open-in-ios` to
// <html> while zoomed, and CSS hides every body child (`.pswp-open-in-ios body
// > * { display:none }`). Setting the gallery's ancestor to display:none cancels
// the CSS fade-in animation that reveals each non-first slide image, and iOS
// Safari frequently fails to repaint on close — leaving the just-zoomed image
// blank until a scroll forces it. The resting-opacity rule in
// product-redesign.css keeps that image's *style* visible after the animation is
// cancelled; this handler forces the actual *repaint* to happen immediately.
//
// Scoped to the product gallery only: toggling the gallery's own display (not
// the whole body) repaints just that subtree and, crucially, does NOT disturb
// the page scroll position — so the gallery restores correctly whether the image
// was fully or only partially visible before the zoom (the old whole-body toggle
// reset scroll to the top). A Flickity resize() then corrects any viewport
// height left stale by the theme's afterChange->goToSlide, which runs while the
// gallery is hidden. No-ops on non-iOS (the class never appears) and off the PDP.
document.addEventListener('DOMContentLoaded', function () {
  var html = document.documentElement;
  var slideshow = document.querySelector('[data-section-type="product"] [data-product-photos]');
  if (!slideshow) return;

  var wasOpen = html.classList.contains('pswp-open-in-ios');

  new MutationObserver(function () {
    var isOpen = html.classList.contains('pswp-open-in-ios');
    if (wasOpen && !isOpen) {
      // Reading offsetHeight between the toggles forces the intermediate
      // (hidden) layout so the browser can't coalesce them into a no-op —
      // guaranteeing a repaint of the gallery subtree when it's shown again.
      slideshow.style.display = 'none';
      void slideshow.offsetHeight; // force reflow
      slideshow.style.display = '';

      var flkty = window.Flickity && Flickity.data(slideshow);
      if (flkty && typeof flkty.resize === 'function') flkty.resize();
    }
    wasOpen = isOpen;
  }).observe(html, { attributes: true, attributeFilter: ['class'] });
});
